import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../SafeIcon';
import { FiTrash2, FiColumns, FiMaximize } from 'react-icons/fi';

const ContextMenu = ({ x, y, onClose, onDelete, onSplit, type }) => {
  useEffect(() => {
    const handleClick = () => onClose();
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [onClose]);

  // Adjust position to stay within viewport
  const adjustedX = Math.min(x, window.innerWidth - 200);
  const adjustedY = Math.min(y, window.innerHeight - 250);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      style={{ top: adjustedY, left: adjustedX }}
      className="fixed z-[200] bg-white border border-gray-200 shadow-2xl rounded-xl py-2 min-w-[190px] overflow-hidden"
    >
      <div className="px-3 py-1.5 text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-50 mb-1">
        {type} Actions
      </div>
      
      {type === 'container' && (
        <>
          <button 
            onClick={() => onSplit(1)}
            className="w-full px-4 py-2.5 text-sm text-gray-600 hover:bg-teal-50 hover:text-teal-600 flex items-center transition-colors"
          >
            <SafeIcon icon={FiMaximize} className="mr-3 w-4 h-4" />
            1 Column
          </button>
          <button 
            onClick={() => onSplit(2)}
            className="w-full px-4 py-2.5 text-sm text-gray-600 hover:bg-teal-50 hover:text-teal-600 flex items-center transition-colors"
          >
            <SafeIcon icon={FiColumns} className="mr-3 w-4 h-4" />
            2 Columns
          </button>
          <button 
            onClick={() => onSplit(3)}
            className="w-full px-4 py-2.5 text-sm text-gray-600 hover:bg-teal-50 hover:text-teal-600 flex items-center transition-colors"
          >
            <SafeIcon icon={FiColumns} className="mr-3 w-4 h-4" />
            3 Columns
          </button>
          <div className="h-px bg-gray-100 my-1" />
        </>
      )}

      <button 
        onClick={onDelete}
        className="w-full px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 flex items-center transition-colors"
      >
        <SafeIcon icon={FiTrash2} className="mr-3 w-4 h-4" />
        Delete Block
      </button>
    </motion.div>
  );
};

export default ContextMenu;